import Vue from 'vue'
import * as types from '../mutation-types'

// initial state
const state = {
  constants: {}
}

// getters
const getters = {
  constants: state => state.constants
}

// actions
const actions = {
  getConstants ({ state, commit }, args) {
    return Vue.axios.get('/constants/', {
      params: args.params,
      headers: args.headers
    }).then((response) => {
      commit(types.RECEIVE_CONSTANTS, { response })
    })
  }
}

// mutations
const mutations = {
  [types.RECEIVE_CONSTANTS] (state, { response }) {
    state.constants = response.data.results
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
